import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
//import Mini from '../components/Mini.vue'
import Members from '../views/Members.vue'
import Dogs from '../views/Dogs.vue'
import MemberView from '../views/MemberView.vue'
import ModPwd from '../views/ModPwd.vue'
import LogOutView from '../views/LogOutView.vue'
import Trials from '../views/Trials.vue'
import Clubs from '../views/Clubs.vue'
//import VuetifyConfirm from 'vuetify-confirm'
import Renew from '../views/Renew.vue'
import NewMbr from '../views/NewMbr.vue'
import Officials from '../views/Officials.vue'

Vue.use(VueRouter)
/*
Vue.use(VuetifyConfirm, {
    icon: 'mdi-alert-circle'
})
*/

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/modpwd',
        name: 'ModPwd',
        component: ModPwd
    },
    {
        path: '/members',
        name: 'Members',
        component: Members,
        meta: {
            requiresAuth: true,
            isAdmin: true
        }
    },
    {
        path: '/trials',
        name: 'Trials',
        component: Trials,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/member/:mbrId?',
        name: 'Member',
        component: MemberView,
        meta: {
            requiresAuth: true,
            isAdmin: true
        }
    },
    {
        path: '/dogs',
        name: 'Dogs',
        component: Dogs,
        meta: {
            requiresAuth: true,
            isAdmin: true
        }
    },
    {
        path: '/logout',
        name: 'logOut',
        component: LogOutView,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/renew',
        name: 'renew',
        component: Renew,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/newmbr',
        name: 'newmbr',
        component: NewMbr,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/clubs',
        name: 'clubs',
        component: Clubs,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/officials',
        name: 'officials',
        component: Officials,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
]

const router = new VueRouter({
    routes
})

export default router
